var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.list_access
        ? _c("v-card", { staticClass: "mb-5 px-4 py-6" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-3" },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.legajos,
                      "item-text": _vm.legajoLabel,
                      "item-value": "id",
                      label: "Legajo",
                      loading: _vm.loading_legajos,
                      clearable: "",
                      "hide-details": "",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.legajo_id,
                      callback: function ($$v) {
                        _vm.legajo_id = $$v
                      },
                      expression: "legajo_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md ps-filter" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.years,
                      label: "Año",
                      clearable: "",
                      "hide-details": "",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.period_year,
                      callback: function ($$v) {
                        _vm.period_year = $$v
                      },
                      expression: "period_year",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md ps-filter" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.months,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Mes",
                      clearable: "",
                      "hide-details": "",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.period_month,
                      callback: function ($$v) {
                        _vm.period_month = $$v
                      },
                      expression: "period_month",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md ps-filter" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.types,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Tipo",
                      clearable: "",
                      "hide-details": "",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md ps-filter" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.statuses,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Estado",
                      clearable: "",
                      "hide-details": "",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.status,
                      callback: function ($$v) {
                        _vm.status = $$v
                      },
                      expression: "status",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "col-md-auto ml-auto",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.loadList(_vm.service)
                        },
                      },
                    },
                    [_vm._v("Buscar")]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm.list_access
        ? _c(
            "div",
            { staticClass: "lc-loose" },
            [
              _c(
                "div",
                { staticClass: "lc-toolbar" },
                [
                  _vm.update_access
                    ? _c("v-simple-checkbox", {
                        staticClass: "mr-2",
                        attrs: {
                          value: _vm.allSelected,
                          indeterminate: _vm.someSelected,
                          disabled: _vm.selectable.length == 0,
                          ripple: false,
                        },
                        on: { input: _vm.toggleAll },
                      })
                    : _vm._e(),
                  _vm.selected.length == 0
                    ? [
                        _c("span", { staticClass: "text-uppercase" }, [
                          _vm._v("Recibos"),
                        ]),
                      ]
                    : [
                        _c(
                          "span",
                          {
                            staticClass: "mr-1",
                            staticStyle: { "font-size": "16px" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.selected.length) + " seleccionados"
                            ),
                          ]
                        ),
                        _c(
                          "v-menu",
                          {
                            attrs: { "offset-y": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            { attrs: { icon: "", small: "" } },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass:
                                                "grey--text text--darken-2",
                                            },
                                            [_vm._v("mdi-dots-vertical")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1679147320
                            ),
                          },
                          [
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        _vm.dialog_publish_many = true
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-icon",
                                      { staticClass: "mr-3" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              small: "",
                                              color: "primary",
                                            },
                                          },
                                          [_vm._v("mdi-send")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-list-item-title", [
                                      _vm._v("Publicar"),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm.selectedPayslips.some(
                                  (p) =>
                                    p.scheduled_publish_at &&
                                    p.status == _vm.draft
                                )
                                  ? _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.openCancelSchedule(
                                              _vm.selectedPayslips
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-icon",
                                          { staticClass: "mr-3" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "purple",
                                                },
                                              },
                                              [_vm._v("mdi-calendar-remove")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-list-item-title", [
                                          _vm._v("Cancelar programación"),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        _vm.dialog_void_many = true
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-icon",
                                      { staticClass: "mr-3" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { small: "", color: "red" },
                                          },
                                          [_vm._v("mdi-cancel")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "red--text" },
                                      [_vm._v("Anular")]
                                    ),
                                  ],
                                  1
                                ),
                                _c("v-divider"),
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        _vm.selected = []
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-icon",
                                      { staticClass: "mr-3" },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-close"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c("v-list-item-title", [
                                      _vm._v("Quitar selección"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                  _c("v-spacer"),
                  _c("v-text-field", {
                    staticClass: "lc-toolbar__search",
                    attrs: {
                      "append-icon": "search",
                      label: "Buscar",
                      "single-line": "",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                ],
                2
              ),
              _c("v-data-iterator", {
                attrs: {
                  items: _vm.loading ? [] : _vm.list,
                  search: _vm.search,
                  "custom-filter": _vm.filterPayslips,
                  loading: _vm.loading,
                  "hide-default-footer": _vm.loading,
                  "items-per-page": 15,
                  "footer-props": { itemsPerPageOptions: [5, 10, 15, 50, -1] },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "loading",
                      fn: function () {
                        return [
                          _c("ListSkeletonRows", {
                            attrs: { count: 6, avatar: "" },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c(
                            "div",
                            { staticClass: "lc-list" },
                            _vm._l(props.items, function (payslip) {
                              return _c(
                                "div",
                                {
                                  key: payslip.id,
                                  staticClass: "lc-item ps-row",
                                  class: {
                                    "lc-item--muted":
                                      payslip.status == _vm.voided,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "lc-main ps-main" },
                                    [
                                      _vm.update_access
                                        ? _c(
                                            "div",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              _c("v-simple-checkbox", {
                                                attrs: {
                                                  value: _vm.selected.includes(
                                                    payslip.id
                                                  ),
                                                  disabled:
                                                    payslip.status ==
                                                    _vm.voided,
                                                  ripple: false,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.toggle(payslip)
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "lc-icon-box lc-icon-box--round",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.legajoInitials(payslip.legajo)
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "lc-info" }, [
                                        _c("div", { staticClass: "lc-title" }, [
                                          _vm._v(
                                            _vm._s(
                                              payslip.legajo
                                                ? payslip.legajo.surname +
                                                    ", " +
                                                    payslip.legajo.name
                                                : "Sin asignar"
                                            )
                                          ),
                                        ]),
                                        _c("div", { staticClass: "lc-sub" }, [
                                          payslip.legajo
                                            ? _c("span", [
                                                _vm._v(
                                                  "Legajo " +
                                                    _vm._s(
                                                      payslip.legajo.nro_legajo
                                                    )
                                                ),
                                              ])
                                            : _vm._e(),
                                          payslip.legajo && payslip.legajo.cuil
                                            ? _c("span", [
                                                _vm._v(
                                                  " · CUIL " +
                                                    _vm._s(payslip.legajo.cuil)
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "lc-meta" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "lc-meta-col ps-col-period",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.periodTitle(payslip)) +
                                              " "
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                payslip.type
                                                  ? payslip.type.name
                                                  : ""
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "lc-meta-col ps-col-payment",
                                        },
                                        [
                                          _vm._v(
                                            " Pago " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  payslip.payment_date
                                                )
                                              ) +
                                              " "
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                payslip.batch_id
                                                  ? "Carga masiva"
                                                  : "Carga individual"
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "ps-col-email" },
                                        [
                                          _c("PayslipEmailStatus", {
                                            attrs: { payslip: payslip },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "ps-col-status" },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                disabled:
                                                  !_vm.statusTooltip(payslip),
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-chip",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color:
                                                                  _vm.payslipStatus(
                                                                    payslip
                                                                  ).color,
                                                                "text-color":
                                                                  _vm.payslipStatus(
                                                                    payslip
                                                                  ).text_color,
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.payslipStatus(
                                                                    payslip
                                                                  ).name
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.statusTooltip(payslip)
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("PayslipActions", {
                                        staticClass: "ps-col-actions",
                                        attrs: {
                                          payslip: payslip,
                                          update_access: _vm.update_access,
                                        },
                                        on: {
                                          preview: _vm.openPreview,
                                          assign: _vm.openAssign,
                                          signature: _vm.openSignature,
                                          publish: _vm.openPublish,
                                          "cancel-schedule": (item) =>
                                            _vm.openCancelSchedule([item]),
                                          events: _vm.openEvents,
                                          void: _vm.openVoid,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      },
                    },
                    {
                      key: "no-data",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "lc-empty" }, [
                            _vm._v(
                              "No hay recibos para los filtros seleccionados."
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "no-results",
                      fn: function () {
                        return [
                          _c(
                            "v-alert",
                            {
                              staticClass: "ma-4",
                              attrs: {
                                value: true,
                                color: "error",
                                icon: "warning",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    "Busqueda sin resultados - " + _vm.search
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1315573468
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c("ModalSignPayslip", {
        attrs: {
          dialog: _vm.dialog_signature,
          payslip: _vm.selected_payslip,
          "signature-loader": _vm.signatureLoader,
        },
        on: { updateDialog: (value) => (_vm.dialog_signature = value) },
      }),
      _c("ModalPayslipEvents", {
        attrs: { dialog: _vm.dialog_events, payslip: _vm.selected_payslip },
        on: { updateDialog: (value) => (_vm.dialog_events = value) },
      }),
      _c("ModalAssignLegajo", {
        attrs: { dialog: _vm.dialog_assign, payslip: _vm.selected_payslip },
        on: {
          updateDialog: (value) => (_vm.dialog_assign = value),
          preview: _vm.openPreview,
          saved: function ($event) {
            return _vm.loadList(_vm.service)
          },
        },
      }),
      _c("ModalPublishPayslips", {
        attrs: { dialog: _vm.dialog_publish, payslips: _vm.publish_payslips },
        on: {
          updateDialog: (value) => (_vm.dialog_publish = value),
          saved: _vm.onBulkSaved,
        },
      }),
      _c("ModalPublishPayslips", {
        attrs: {
          dialog: _vm.dialog_publish_many,
          payslips: _vm.selectedPayslips,
        },
        on: {
          updateDialog: (value) => (_vm.dialog_publish_many = value),
          saved: _vm.onBulkSaved,
        },
      }),
      _c("ModalVoidPayslip", {
        attrs: { dialog: _vm.dialog_void, payslip: _vm.selected_payslip },
        on: {
          updateDialog: (value) => (_vm.dialog_void = value),
          saved: function ($event) {
            return _vm.loadList(_vm.service)
          },
        },
      }),
      _c("ModalVoidPayslips", {
        attrs: { dialog: _vm.dialog_void_many, payslips: _vm.selectedPayslips },
        on: {
          updateDialog: (value) => (_vm.dialog_void_many = value),
          saved: _vm.onBulkSaved,
        },
      }),
      _c("DialogYesNo", {
        attrs: {
          open: _vm.dialog_cancel_schedule,
          title: "Cancelar programación",
          message: _vm.cancelScheduleMessage,
          loading: _vm.loading_cancel,
          maxWidth: 450,
          nameCancel: "Volver",
          nameAccept: "Cancelar programación",
        },
        on: {
          cancel: function ($event) {
            _vm.dialog_cancel_schedule = false
          },
          accept: _vm.cancelSchedule,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }